import {
    BRANCH_LIST_REQUEST,
    BRANCH_LIST_SUCCESS,
    BRANCH_LIST_FAIL,
    BRANCH_LIST_RESET
} from '../constants/branchConstants'

export const branchListReducers = (state = { branches: [] }, action) => {
    switch (action.type) {
        case BRANCH_LIST_REQUEST:
            return { loading: true }
        case BRANCH_LIST_SUCCESS:
            return { loading: false, branches: action.payload }
        case BRANCH_LIST_FAIL:
            return { loading: false, error: action.payload }
        case BRANCH_LIST_RESET:
            return { loading: false, state: { branches: [] } }
        default:
            return state;
    }
}